import { createContext } from "react";

const disputeContext = createContext();

export default disputeContext;
